import {SavedBeneficiariesAddress} from "./savedBeneficiariesAddress";
import {SavedBillingAddress} from "./savedBillingAddress";
import {Mandate} from "./mandate";
import {SavedAuthority} from "./savedAuthority";
import {SavedLandregisterfolio} from "./savedLandregisterfolio";

export class SavedProperty{

  id:string;
  platformProfileId: number;
  mandateId: number;
  name:string;
  street:string;
  house_number:string;
  zip:string;
  town:string;
  ownId:string;
  contactMail:string;

  billingAddress: SavedBillingAddress;
  beneficiariesAddress: SavedBeneficiariesAddress;
  landregisterfolios: Array<SavedLandregisterfolio> = [];
  authorities: Array<SavedAuthority>;

  mandate: Mandate;

}
